<template>
  <main>
    <div class="inner_wrap">
      <ul class="select_wrap">
        <li @click="scrollToSection('.content1')">
          신학기 전공책 <br />
          할인대전
        </li>
        <li @click="scrollToSection('.content2')">
          캠퍼스북 <br />
          E-BOOK ONLY
        </li>
        <li @click="scrollToSection('.content3')">
          토스페이 <br />
          결제 혜택
        </li>
      </ul>
      <section class="content1">
        <div class="inner">
          <div>
            <img src="@/assets/images/event/2025-1-term/con1_1.png" alt="" />
          </div>
        </div>
        <div class="con1_2">
          <img src="@/assets/images/event/2025-1-term/con1_2.png" alt="" />
        </div>
        <div class="coupon_wrap">
          <div v-if="!isEventOpen" class="user_check">
            <div class="non_event">
              <span class="txt">
                이벤트 <br />
                오픈전 입니다!
              </span>
              <span class="apply" style="cursor: auto;">
                2월 26일 오픈
              </span>
            </div>
          </div>
          <img
            :class="[isEventOpen ? 'active' : '']"
            src="@/assets/images/event/2025-1-term/con1_3.png"
            alt=""
          />
          <button
            class="receive ten_per"
            @click="oneTouchCouponDownload"
          ></button>
          <router-link class="my_page" to="/account"></router-link>
          <div class="inner">
            <img
              :class="[isEventOpen ? 'active' : '']"
              src="@/assets/images/event/2025-1-term/con1_4.png"
              alt=""
            />
            <button
              class="receive all"
              @click="oneTouchCouponDownload"
            ></button>
          </div>
        </div>
      </section>
      <section class="content2">
        <div class="inner">
          <div>
            <img src="@/assets/images/event/2025-1-term/con2_1.png" alt="" />
          </div>
        </div>
        <div>
          <img src="@/assets/images/event/2025-1-term/con2_2.png" alt="" />
        </div>
        <ul class="price_type">
          <li>
            <div class="phar_type">
              구매(소장)
            </div>
            <div class="nber">
              <span>49,000원</span>
            </div>
          </li>
          <li>
            <div class="phar_type">
              대여(12개월)
            </div>
            <div class="nber">
              <span>44,100원</span>
              <span>(10% 할인)</span>
            </div>
          </li>
          <li>
            <div class="phar_type">
              대여(6개월)
            </div>
            <div class="nber">
              <span>39,200원</span>
              <span>(20% 할인)</span>
            </div>
          </li>
        </ul>
        <div class="inner">
          <router-link
            to="/store/books/BO-20250206000100001"
            style="display: block;"
          >
            <img src="@/assets/images/event/2025-1-term/con2_3.png" alt="" />
          </router-link>
        </div>
      </section>
      <section class="content3">
        <div class="inner">
          <img src="@/assets/images/event/2025-1-term/con3_1.png" alt="" />
        </div>
        <div class="inner">
          <div class="txt_wrap1">
            <span>캠퍼스북 X 토스페이</span>
            <div><span class="pink">결제 할인</span> 이벤트</div>
          </div>
        </div>
        <div>
          <img src="@/assets/images/event/2025-1-term/con3_2.png" alt="" />
        </div>
        <div class="inner">
          <ul class="txt_wrap2">
            <li>
              <h2>EVENT 01</h2>
              <div class="fir">
                <span>대상</span>
                <span>토스프라임 가입 고객</span>
              </div>
              <div class="sec">
                <span>혜택</span>
                <span
                  >결제 시 <span class="yellow">4%적립</span>(최대
                  12,000원)</span
                >
              </div>
              <img src="@/assets/images/event/2025-1-term/con3_3.png" alt="" />
            </li>
            <li>
              <h2>EVENT 02</h2>
              <div class="fir">
                <span>대상</span>
                <div>
                  토스 실시간 계좌이체
                  <span class="yellow">결제고객 누구나</span>
                </div>
              </div>
              <div class="sec mb">
                <span>혜택</span>
                <span>
                  1만원 이상 결제시 <span class="yellow">0.5% 할인</span>
                  <span class="gray_ft"
                    >※횟수제한 없음, 예산 소진시 조기 종료</span
                  >
                </span>
              </div>
              <div class="third">
                <span>기간</span>
                <span>25년 02월 24일 ~ 26년 02월 23일 까지</span>
              </div>
              <img src="@/assets/images/event/2025-1-term/con3_4.png" alt="" />
            </li>
          </ul>
          <div class="inner">
            <router-link to="/store/A/books/A" style="display: block;">
              <img src="@/assets/images/event/2025-1-term/con2_3.png" alt="" />
            </router-link>
          </div>
        </div>
      </section>
      <section class="content5">
        <div>친구에게 공유하고 함께 이벤트 참여하세요!</div>
        <ul class="share_wrap">
          <!-- <li>
              <img
                src="@/assets/images/event/2025-1-competition/event_kakao.png"
                alt=""
              />
              카카오톡 공유
            </li> -->
          <li
            :class="{ 'copied': isCopied }"
            class="copy_button"
            @click="copyToClipboard"
          >
            <img
              src="@/assets/images/event/2025-1-competition/event_share.png"
              alt=""
            />
            링크 복사하기
            <div v-if="showTooltip" class="tooltip">링크 복사 되었습니다.</div>
          </li>
        </ul>
      </section>
      <div class="caution_wrap" @click="toggleCaution(0)">
        <span class="txt" :class="{ 'active': cautionStates[0] }">
          유의사항
        </span>
        <transition @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-show="cautionStates[0]" class="slide_list">
            <div class="cau_wrap1">
              <h2 class="point_save">캠퍼스북 신학기대전 할인쿠폰 유의사항</h2>
              <ul>
                <li>· 쿠폰 유효기간: 2025년 3월 31일까지 사용 가능합니다.</li>
                <li>
                  · 캠퍼스북 신학기대전 할인쿠폰은 캠퍼스북 회원 대상으로
                  제공되는 혜택으로, 회원 로그인 후 발급받을 수 있습니다.
                </li>
                <li>
                  · 캠퍼스북 비회원의 경우 쿠폰 할인 혜택을 받을 수 없습니다.
                </li>
                <li>
                  · 쿠폰은 신학기대전 프로모션 할인가에서 추가로 할인 적용되며,
                  일부 할인 제외 도서는 적용되지 않습니다.
                </li>
                <li>
                  · 도서정가제로 인하여 이미 할인이 추가로 들어간 소장도서의
                  경우에는 쿠폰 사용이 불가능합니다.
                </li>
                <li>· 본 쿠폰은 하나의 ID당 1회만 발급받을 수 있습니다.</li>
                <li>
                  · 본 쿠폰은 전체 카테고리에 등록된 상품 구매 시에만 적용
                  가능합니다.
                </li>
                <li>· 본 쿠폰은 결제 창에서 선택하여 사용할 수 있습니다.</li>
                <li>
                  · 본 쿠폰은 한 주문에서 여러 권의 도서에 각각 적용 가능하며,
                  도서 1권당 1개의 쿠폰이 사용됩니다.
                </li>
                <li>
                  · 반드시 쿠폰 사용 기간을 확인하신 후, 기간 내 사용해 주시길
                  바랍니다.
                </li>
                <li>
                  · 해당 이벤트는 사전 고지 없이 혜택 변경 및 조기 종료될 수
                  있습니다.
                </li>
              </ul>
            </div>
            <div class="cau_wrap2">
              <h2 class="point_save">토스 퀵 계좌이체 유의사항</h2>
              <ul>
                <li>
                  · 즉시 할인 혜택 적용 시 결제 화면에 "즉시 할인"으로
                  표시됩니다.
                </li>
                <li>
                  · 즉시 할인 혜택 표시를 꼭 확인하신 후 프로모션 이용을
                  부탁드립니다.
                </li>
                <li>· 퀵계좌 결제건은 부분/전체취소 가능합니다.</li>
                <li>
                  · 토스 퀵계좌이체 프로모션은 당사 및 제휴사 사정에 의해
                  변경/종료될 수 있습니다.
                </li>
                <li>
                  · 부분 취소할 경우, 부분 취소 비율만큼 혜택이 줄어들어 최종
                  환불 금액이 정해집니다.
                </li>
                <li>
                  · 전체 취소할 경우, 할인 제외한 실제 결제한 금액만큼만
                  환불받습니다.
                </li>
                <li>· 현금영수증은 즉시 할인 금액을 제외하고 발행됩니다.</li>
                <li>· 법인 계좌로 결제 시엔 혜택 받으실 수 없습니다.</li>
                <li>
                  · 1원 단위는 절사하여 할인 적용됩니다. (할인율 계산 시
                  3,746원인 경우, 실질적으로는 3,640원 할인)
                </li>
              </ul>
            </div>
            <div class="cau_wrap3">
              <h2 class="point_save">토스 프라임 4% 캐시백 유의사항</h2>
              <ul>
                <li>
                  · 토스 프라임 회원에게만 지급되며, 토스프라임 월 최대 적립금액
                  12,000원의 잔여한도 내에서 캐시백 포인트가 지급됩니다.
                </li>
              </ul>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <Transition name="modal-fade">
      <Modal v-if="showCouponModal" @close="toggleCouponModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleCouponModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner cart_alert_wrap">
              <div class="cell">
                <span class="cart_alert_msg">
                  <p>{{ couponMessage }}</p>
                  <!-- <p>할인 쿠폰이 발급되었습니다.</p> -->
                  <!-- <p>주문시 사용가능합니다.</p> -->
                </span>
              </div>
              <div class="btn_wrap">
                <button class="box_btn dull" @click="toggleCouponModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
                <button class="box_btn" @click="navigateToCoupon">
                  <span class="an_t">
                    쿠폰함으로 이동
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal v-if="showCouponErrorModal" @close="toggleCouponErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleCouponErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner cart_alert_wrap">
              <div class="cell">
                <span class="cart_alert_msg">
                  <!-- <p>쿠폰 수령 횟수를 초과했습니다</p> -->
                  <!-- <p>쿠폰은 3회까지 다운로드 가능합니다</p> -->
                  <p>{{ couponErrorMessage }}</p>
                </span>
              </div>
              <div class="btn_wrap">
                <button class="box_btn dull" @click="toggleCouponErrorModal">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Transition>
  </main>
</template>
<script>
import { ONE_TOUCH_COUPON } from '@/store/types'
import { mapGetters } from 'vuex'
import swiperSettings from '@/data/swiperSettings'
export default {
  name: 'Term2025-1-1',
  data() {
    return {
      cautionStates: [false, false],
      couponMessage: '',
      couponErrorMessage: '',
      showCouponModal: false,
      showCouponErrorModal: false,
      ...swiperSettings,
      isCopied: false,
      showTooltip: false,
      tooltipTimeout: null
    }
  },
  computed: {
    ...mapGetters(['getCurrentUser']),
    isEventOpen() {
      const today = new Date()
      const eventDate = new Date('2025-02-25T10:30:00') // ISO 8601 형식으로 시간 추가
      return today >= eventDate
    }
  },
  methods: {
    toggleCaution(index) {
      this.$set(this.cautionStates, index, !this.cautionStates[index])
    },
    beforeEnter(el) {
      el.style.height = '0'
      el.style.opacity = '0'
    },
    enter(el) {
      const height = el.scrollHeight
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = `${height}px`
      el.style.opacity = '1'
    },
    leave(el) {
      el.style.transition = 'height 0.5s ease, opacity 0.5s ease'
      el.style.height = '0'
      el.style.opacity = '0'
    },
    scrollToSection(targetSelector) {
      const targetElement = document.querySelector(targetSelector)

      if (targetElement) {
        // 요소의 위치와 계산된 스타일 가져오기
        const elementRect = targetElement.getBoundingClientRect()
        const computedStyle = window.getComputedStyle(targetElement)

        // 패딩 및 마진 계산
        const marginTop = parseInt(computedStyle.marginTop)
        const paddingTop = parseInt(computedStyle.paddingTop)

        // 요소의 절대 위치 계산
        const absoluteElementTop = elementRect.top + window.pageYOffset

        // 최종 오프셋 계산 (패딩 및 마진 포함)
        let finalOffset = absoluteElementTop - marginTop - paddingTop

        if (window.innerWidth <= 1022) {
          finalOffset -= 60 // 60px 추가 오프셋
        }
        if (window.innerWidth <= 768) {
          finalOffset -= 12
        }
        if (window.innerWidth <= 480) {
          finalOffset -= 12
        }
        window.scrollTo({
          top: finalOffset,
          behavior: 'smooth'
        })
      }
    },
    toggleCouponModal() {
      this.showCouponModal = !this.showCouponModal
    },
    toggleCouponErrorModal() {
      this.showCouponErrorModal = !this.showCouponErrorModal
    },
    async oneTouchCouponDownload() {
      if (!this.getCurrentUser) {
        if (confirm('로그인이 필요합니다. 로그인 하시겠습니까?')) {
          this.$router.push({ name: 'login' })
          return
        } else {
          return
        }
      }
      // 이 아래 쿠폰 받기 구현.
      // 클릭하면 받으시겠습니까? 질문 없이 즉시 받기
      // 받고나서 확인 + 쿠폰함 이동 버튼 - LIKE 책을 장바구니에 넣었을 때처럼

      // 쿠폰 수령 후 알림창 띄워주는 부분.
      // 알림창은 장바구니 부분을 참고하여 만들어 짐.
      let resp = await this.$store.dispatch(ONE_TOUCH_COUPON)
      let result = resp.data.result
      switch (result.state) {
        case 'success':
          this.couponMessage = result.modal
          this.showCouponModal = true
          break
        case 'fail':
          this.couponErrorMessage = result.modal
          this.showCouponErrorModal = true
          break
        case 'error':
          alert(result.message)
          break
        default:
          console.log('out of case')
      }
    },
    navigateToCoupon() {
      this.$router.push({ name: 'discount' })
    },
    copyToClipboard() {
      // 현재 URL 가져오기
      const currentUrl = window.location.href

      // 복사를 위한 임시 textarea 요소 생성
      const textarea = document.createElement('textarea')
      textarea.value = currentUrl
      textarea.style.position = 'fixed' // 하단으로 스크롤 방지
      document.body.appendChild(textarea)
      textarea.select()

      try {
        // 복사 명령 실행
        const successful = document.execCommand('copy')
        if (successful) {
          this.showCopiedFeedback()
        } else {
          console.error('복사 명령이 실패했습니다')
        }
      } catch (err) {
        console.error('복사 작업 중 오류 발생:', err)
      }

      // 정리 작업
      document.body.removeChild(textarea)
    },
    showCopiedFeedback() {
      // 시각적 피드백을 위한 상태 설정
      this.isCopied = true
      this.showTooltip = true

      // 기존 타임아웃 제거
      if (this.tooltipTimeout) {
        clearTimeout(this.tooltipTimeout)
      }

      // 일정 시간 후 상태 초기화
      this.tooltipTimeout = setTimeout(() => {
        this.isCopied = false
        this.showTooltip = false
      }, 2000)
    }
  }
}
</script>
<style lang="scss" scoped>
// apply
.tooltip {
  position: absolute;
  bottom: 0px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  z-index: 10;
  animation: fadeIn 0.3s ease-in-out;
  &::after {
    content: '';
    position: absolute;
    top: -6px;
    left: 50%;
    transform: translateX(-50%);
    border-width: 0 6px 6px 6px;
    border-style: solid;
    border-color: transparent transparent rgba(0, 0, 0, 0.8) transparent;
  }
}
.my_page {
  position: absolute;
  width: 100%;
  height: 26vw;
  top: 50%;
  left: 0;
}
img {
  width: 100%;
  height: 100%;
}
main {
  width: 100%;
  margin-bottom: 100px;
}
section {
  position: relative;
  width: 100%;
}
.inner_wrap {
  max-width: 1120px;
  margin: 0 auto;
  background: #000000;
  text-align: center;
}
.inner {
  max-width: 790px;
  margin: 0 auto;
}
.circle {
  position: relative;
  display: inline-block;
  margin-bottom: 25px;
  &::before {
    content: attr(data-num);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 43px;
    color: #000000;
  }
}
.main_topic {
  margin-bottom: 15px;
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 52px;
  letter-spacing: 1px;
}
.sub_topic {
  display: block;
  margin-bottom: 75px;
  font-weight: 600;
  font-size: 42px;
  line-height: 42px;
  color: #f1f0f0;
}
.coupon10 {
  position: relative;
  margin: 0 auto 35px;
  width: 50%;
  &::after {
    content: 'X3';
    position: absolute;
    top: -45px;
    right: -40px;
    width: 110px;
    height: 110px;
    border: 4px solid #fc6de4;
    border-radius: 100%;
    background-color: #fff57d;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 46px;
    line-height: 110px;
    color: #000000;
  }
}
.coupon5 {
  margin: 0 auto 35px;
  width: 50%;
}
.coupon_detail {
  display: block;
  margin-top: 30px;
  font-weight: 600;
  font-size: 32px;
  line-height: 32px;
  color: #d8d8d8;
}
.select_wrap {
  display: flex;
  li {
    flex: 1;
    padding: 23px 0;
    background-color: #ee52d9;
    border-right: 1px solid #ffffff;
    text-transform: uppercase;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 26px;
    color: #fff;
    cursor: pointer;
    &:nth-child(3) {
      border-right: 0;
    }
  }
}
.caution_wrap {
  padding: 100px 100px 65px;
  background-color: #353535;
  user-select: none;
  cursor: pointer;
  &.user_cause {
    padding: 0;
  }
  .txt {
    display: flex;
    // justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    font-family: 'pretendard-light';
    font-size: 45px;
    line-height: 45px;
    color: #fff;
    &::after {
      content: '';
      display: block;
      background: url('../../../assets/images/event/2025-1-competition/arrow.png')
        no-repeat center center;
      background-size: contain;
      width: 56px;
      height: 27px;
      transform: rotate(-180deg);
    }
    &.active {
      &::after {
        transform: rotate(0);
      }
    }
  }
  .slide_list {
    // width: 600px;
    margin: 0 auto;
    text-align: left;
    overflow: hidden;
    list-style-type: disc;
    font-size: 22px;
    color: #fff;
    .point_save {
      margin-bottom: 10px;
    }
    .cau_wrap1,
    .cau_wrap2,
    .cau_wrap3 {
      line-height: 43px;
      ul {
        li {
          line-height: 43px;
        }
      }
      h2 {
        font-size: 45px;
        margin: 50px 0 40px;
      }
    }
  }
}
.use_method {
  margin-top: 30px;
  font-weight: 600;
  font-size: 26px;
  line-height: 26px;
  letter-spacing: 1px;
  color: #d8d8d8;
}

// cont
.content1 {
  // height: 1205px;
  padding: 60px 0 0;
  .con1_2 {
    margin: 30px 0 0;
  }
  .coupon_wrap {
    position: relative;
    .receive {
      position: absolute;
      width: 100%;
      left: 50%;
      transform: translateX(-50%);
      &.ten_per {
        top: 7%;
        height: 372px;
      }
      &.all {
        height: 150px;
      }
    }
    img {
      filter: blur(7px);
      -webkit-filter: blur(7px);
      &.active {
        filter: blur(0);
        -webkit-filter: blur(0);
      }
    }
  }
  .user_check {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    // transform: translateX(-50%);
    width: 100%;
    height: 100%;
    .non_event {
      width: 680px;
      padding: 55px 63px 25px;
      background-color: #e4e3ea;
      border-radius: 20px;
      box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.5);
    }
    .non_member {
      width: 680px;
      padding: 55px 63px 25px;
      background-color: #e4e3ea;
      border-radius: 20px;
      box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.5);
    }
    .txt {
      display: block;
      margin-bottom: 50px;
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 45px;
      line-height: 53px;
      color: #201756;
    }
    .apply {
      display: block;
      width: 360px;
      margin: 0 auto;
      padding: 20px 14px;
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 52px;
      line-height: 44px;
      border-radius: 40px;
      background: #51499b;
      cursor: pointer;
      color: #f7d608;
    }
  }
}
.content2 {
  padding: 120px 0 0;
  .price_type {
    display: flex;
    justify-content: center;
    margin: 50px 0 70px;
    li {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;
      border-right: 1px solid #fff;
      &:last-child {
        border-right: 0;
      }
    }
    .phar_type {
      position: relative;
      z-index: 1;
      font-weight: 600;
      font-family: 'pretendard-medium';
      font-size: 37px;
      line-height: 82px;
      color: #000;
      &::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: -1;
        display: block;
        background: url('../../../assets/images/event/2025-1-term/gradaytion.png')
          no-repeat center center;
        background-size: contain;
        width: 275px;
        height: 82px;
      }
    }
    .nber {
      span {
        display: block;
        font-family: 'pretendard-medium';
        font-weight: 600;
        font-size: 55px;
        line-height: 55px;
        &:nth-child(1) {
          margin-bottom: 10px;
          color: #fff;
        }
        &:nth-child(2) {
          color: #f7d608;
        }
      }
    }
  }
}
.yellow {
  font-family: 'pretendard-light';
  color: #f7d608;
}
.content3 {
  padding: 120px 0 120px;
  .txt_wrap1 {
    > span,
    > div {
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 74px;
      line-height: 74px;
      color: #fff;
    }
    > span {
      display: block;
      margin-bottom: 20px;
    }
    > div {
      font-size: 94px;
      line-height: 94px;
      letter-spacing: 0.5px;
    }
    .pink {
      color: #ee52d9;
    }
  }
  .txt_wrap2 {
    display: flex;
    flex-direction: column;
    gap: 140px;
    margin-bottom: 65px;
    text-align: left;
    li {
      display: flex;
      flex-direction: column;
      gap: 30px;
    }
    h2 {
      font-family: 'pretendard-medium';
      font-weight: 600;
      font-size: 56px;
      line-height: 56px;
      color: #808080;
    }
    .fir,
    .sec,
    .third {
      display: flex;
      gap: 40px;
      color: #fff;
      span,
      > div {
        &:nth-child(1) {
          font-family: 'pretendard-medium';
          font-weight: 600;
          font-size: 39px;
          line-height: 39px;
        }
        &:nth-child(2) {
          font-size: 39px;
          line-height: 39px;
        }
      }
    }
    .fir {
      > div {
        .yellow {
          font-family: 'pretendard-light';
          color: #f7d608;
        }
      }
    }
    .sec {
      margin-bottom: 60px;
      &.mb {
        margin-bottom: 0;
        .gray_ft {
          display: block;
          margin-top: 15px;
          font-size: 30px;
          line-height: 30px;
        }
        .yellow {
          font-family: 'pretendard-light';
          color: #f7d608;
        }
      }
    }
    .third {
      margin-bottom: 60px;
    }
  }
}
.content4 {
  padding: 80px 0 0;
  background-color: #898ef7;
  overflow: hidden;
  .main_topic {
    color: #fff57d;
  }
  .pad_mock {
    // display: grid;
    // grid-template-columns: 1fr 1fr 1fr 1fr;
    // margin: 0 -50px 35px;
    &.pad_mock1 {
      margin: 0 -50px 35px;
    }
    &.pad_mock2 {
      margin: 0 -30px 35px;
    }
    .img_wrap {
      // width: 300px !important;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.content5 {
  padding: 40px 0 45px 0;
  background: #fff;
  > div {
    margin-bottom: 25px;
    font-family: 'pretendard-medium';
    font-weight: 600;
    font-size: 38px;
    letter-spacing: 0.2px;
  }
  .share_wrap {
    display: flex;
    justify-content: center;
    gap: 80px;
    li {
      display: flex;
      flex-direction: column;
      font-size: 24px;
      cursor: pointer;
      img {
        width: 169px;
      }
    }
  }
}
// 얼럿창 스타일
.ly_pop_msg .cell {
  height: auto;
  padding-bottom: 0;
  p {
    color: #008df3;
  }
}
@media (max-width: 1120px) {
  .content1 .coupon_wrap .receive.ten_per {
    height: 35vw;
  }
  .content1 .coupon_wrap .receive.all {
    height: 18vw;
  }
}
@media (max-width: 960px) {
  .caution_wrap {
    padding: 65px 100px 65px;
  }
  .caution_wrap .txt {
    margin-bottom: 0;
  }
  .caution_wrap .slide_list .cau_wrap1 ul li,
  .caution_wrap .slide_list .cau_wrap2 ul li,
  .caution_wrap .slide_list .cau_wrap3 ul li {
    font-size: 20px;
  }
  .caution_wrap .slide_list .cau_wrap1 h2,
  .caution_wrap .slide_list .cau_wrap2 h2,
  .caution_wrap .slide_list .cau_wrap3 h2 {
    font-size: 32px;
    margin: 40px 0 30px;
  }
  .content2 .price_type .phar_type {
    font-size: 27px;
    line-height: 67px;
  }
  .content2 .price_type .phar_type::before {
    width: 224px;
    height: 76px;
  }
  .content2 .price_type .nber span {
    font-size: 46px;
    line-height: 46px;
  }
  .content3 .main_topic {
    &::before {
      left: 10px;
    }
  }
  .content3 .sub_topic {
    &::after {
      right: 10px;
    }
  }
  .content3 .price {
    &::before {
      left: 0;
    }
  }
  .content3 .bottom_txt {
    &::after {
      right: 0;
    }
  }
}
@media (max-width: 768px) {
  //apply
  .inner {
    max-width: 480px;
  }
  .caution_wrap {
    padding: 45px 0 45px;
    .txt {
      font-size: 28px;
      line-height: 28px;
      letter-spacing: 1px;
      padding-left: 70px;
    }
    .slide_list {
      width: 460px;
      li {
        font-size: 21px;
      }
    }
  }
  .caution_wrap .slide_list .cau_wrap1 ul li,
  .caution_wrap .slide_list .cau_wrap2 ul li,
  .caution_wrap .slide_list .cau_wrap3 ul li {
    font-size: 18px;
  }
  .caution_wrap .slide_list .cau_wrap1 h2,
  .caution_wrap .slide_list .cau_wrap2 h2,
  .caution_wrap .slide_list .cau_wrap3 h2 {
    font-size: 25px;
    margin: 30px 0 20px;
  }
  .select_wrap {
    li {
      padding: 34px 0 20px;
      font-size: 21px;
    }
  }
  .use_method {
    margin-top: 13px;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: -0.2px;
  }
  // cont
  .content1 {
    .txt_wrap {
      top: 40px;
      left: 30px;
      h2 {
        font-size: 60px;
        line-height: 63px;
        margin-bottom: 20px;
      }
      span {
        font-size: 25px;
        line-height: 31px;
      }
    }
    .user_check {
      .non_event {
        width: 480px;
        padding: 25px 63px 25px;
      }
      .non_member {
        width: 480px;
        padding: 25px 63px 25px;
      }
      .txt {
        margin-bottom: 20px;
        font-size: 39px;
        line-height: 44px;
      }
      .apply {
        width: 300px;
        padding: 20px 0px;
        font-size: 36px;
        line-height: 25px;
      }
    }
  }
  .content2 {
    padding-top: 60px;
    padding-bottom: 50px;
  }
  .content2 .price_type .phar_type {
    font-size: 20px;
    line-height: 50px;
  }
  .content2 .price_type .phar_type::before {
    width: 161px;
    height: 76px;
  }
  .content2 .price_type .nber span {
    font-size: 31px;
    line-height: 31px;
  }
  .content3 {
    padding: 40px 0;
  }
  .content3 .txt_wrap2 {
    gap: 105px;
    margin-bottom: 43px;
  }
  .content3 .txt_wrap2 h2 {
    font-size: 38px;
    line-height: 38px;
  }
  .content3 .txt_wrap2 li {
    gap: 20px;
  }
  .content3 .txt_wrap2 .sec {
    margin-bottom: 40px;
  }
  .content3 .txt_wrap2 .fir span:nth-child(1),
  .content3 .txt_wrap2 .fir > div:nth-child(1),
  .content3 .txt_wrap2 .sec span:nth-child(1),
  .content3 .txt_wrap2 .sec > div:nth-child(1),
  .content3 .txt_wrap2 .third span:nth-child(1),
  .content3 .txt_wrap2 .third > div:nth-child(1) {
    font-size: 24px;
    line-height: 24px;
  }

  .content3 .txt_wrap2 .fir span:nth-child(2),
  .content3 .txt_wrap2 .fir > div:nth-child(2),
  .content3 .txt_wrap2 .sec span:nth-child(2),
  .content3 .txt_wrap2 .sec > div:nth-child(2),
  .content3 .txt_wrap2 .third span:nth-child(2),
  .content3 .txt_wrap2 .third > div:nth-child(2) {
    font-size: 24px;
    line-height: 24px;
  }
  .content3 .txt_wrap2 .sec.mb .gray_ft {
    font-size: 20px;
    line-height: 20px;
  }
  .content3 .txt_wrap1 > span,
  .content3 .txt_wrap1 > div {
    font-size: 57px;
    line-height: 57px;
  }
  .content3 .txt_wrap1 > div {
    font-size: 70px;
    line-height: 70px;
  }
  .content4 {
    padding: 40px 0 0;
    .pad_mock {
      margin-bottom: 15px;
    }
  }
  .content5 {
    padding: 40px 0 40px 0;
    > div {
      font-size: 28px;
      line-height: 28px;
    }
    .share_wrap {
      li {
        font-size: 18px;
        img {
          width: 135px;
        }
      }
    }
  }
}
@media (max-width: 480px) {
  //apply
  .inner {
    max-width: 355px;
  }
  .select_wrap {
    li {
      padding: 18px 0;
      font-size: 16px;
    }
  }
  .caution_wrap .txt {
    margin-bottom: 10px;
    padding-left: 12px;
  }
  .caution_wrap .slide_list {
    width: 355px;
    font-size: 16px;
  }
  .caution_wrap .slide_list .cau_wrap1 ul li,
  .caution_wrap .slide_list .cau_wrap2 ul li,
  .caution_wrap .slide_list .cau_wrap3 ul li {
    font-size: 15px;
  }
  .caution_wrap .slide_list .cau_wrap1 h2,
  .caution_wrap .slide_list .cau_wrap2 h2,
  .caution_wrap .slide_list .cau_wrap3 h2 {
    font-size: 18px;
    margin: 20px 0 15px;
  }
  .use_method {
    margin-top: 9px;
    font-size: 11px;
    line-height: 11px;
    letter-spacing: -0.2px;
  }
  //cont
  .content1 {
    .txt_wrap {
      top: 40px;
      left: 30px;
      h2 {
        font-size: 43px;
        line-height: 46px;
        margin-bottom: 14px;
      }
      span {
        font-size: 19px;
        line-height: 24px;
      }
    }
    .user_check {
      .non_event {
        width: 355px;
        padding: 25px 25px 25px;
      }
      .non_member {
        width: 355px;
        padding: 25px 25px 25px;
      }
      .txt {
        font-size: 29px;
        line-height: 35px;
      }
      .apply {
        width: 260px;
        font-size: 28px;
        line-height: 14px;
      }
    }
  }
  .content2 {
    padding-top: 40px;
    padding-bottom: 40px;
    .price_type {
      margin: 50px 0 35px;
    }
  }
  .content2 .price_type .phar_type {
    font-size: 14px;
    line-height: 20px;
  }
  .content2 .price_type .phar_type::before {
    width: 115px;
    height: 76px;
  }
  .content2 .price_type .nber span {
    font-size: 18px;
    line-height: 18px;
  }
  .content3 {
    padding: 30px 0;
    .book_mock {
      margin: 0 auto 21px;
      li {
        // height: 155px;
      }
    }
    .bottom_txt {
      margin-bottom: 11px;
      font-size: 20px;
      line-height: 25px;
    }
    .price {
      margin-bottom: 15px;
      font-size: 31px;
      line-height: 31px;
    }
  }

  .content3 .txt_wrap2 {
    gap: 105px;
    margin-bottom: 43px;
  }
  .content3 .txt_wrap2 h2 {
    font-size: 29px;
    line-height: 29px;
  }
  .content3 .txt_wrap2 li {
    gap: 12px;
  }
  .content3 .txt_wrap2 .sec {
    margin-bottom: 20px;
  }
  .content3 .txt_wrap2 .third {
    margin-bottom: 25px;
  }
  .content3 .txt_wrap2 .fir span:nth-child(1),
  .content3 .txt_wrap2 .fir > div:nth-child(1),
  .content3 .txt_wrap2 .sec span:nth-child(1),
  .content3 .txt_wrap2 .sec > div:nth-child(1),
  .content3 .txt_wrap2 .third span:nth-child(1),
  .content3 .txt_wrap2 .third > div:nth-child(1) {
    font-size: 17px;
    line-height: 17px;
  }

  .content3 .txt_wrap2 .fir span:nth-child(2),
  .content3 .txt_wrap2 .fir > div:nth-child(2),
  .content3 .txt_wrap2 .sec span:nth-child(2),
  .content3 .txt_wrap2 .sec > div:nth-child(2),
  .content3 .txt_wrap2 .third span:nth-child(2),
  .content3 .txt_wrap2 .third > div:nth-child(2) {
    font-size: 17px;
    line-height: 17px;
  }
  .content3 .txt_wrap2 .sec.mb .gray_ft {
    font-size: 14px;
    line-height: 14px;
  }
  .content3 .txt_wrap1 > span,
  .content3 .txt_wrap1 > div {
    font-size: 40px;
    line-height: 40px;
  }
  .content3 .txt_wrap1 > div {
    font-size: 50px;
    line-height: 50px;
  }
  .content4 {
    padding: 30px 0 0;
    .pad_mock {
      margin-bottom: 12px;
    }
  }
  .content5 {
    padding: 30px 0 12px 0;
    > div {
      font-size: 19px;
      line-height: 19px;
    }
    .share_wrap {
      gap: 25px;
      li {
        font-size: 14px;
        img {
          width: 90px;
        }
      }
    }
  }
}
</style>
